const Dataplant = require('./Dataplant')

module.exports = Dataplant
